"use client";
import { DirectusImage } from "@/components/DirectusImage";
import { cn } from "@/lib/utils";
import { useDebounceFn } from "ahooks";
import { useState } from "react";
import Swiper, { SwiperSlide } from "@/components/ui/swiper";

export default function Industry(props: {
  data?: {
    title?: string;
    data?: {
      title: string;
      description: string;
      image: string;
      icon: string;
    }[];
  };
}) {
  const [value, setValue] = useState(0);

  const { run } = useDebounceFn(
    (index: number) => {
      setValue(index);
    },
    { wait: 150 }
  );

  return (
    <>
      <div className="relative h-auto w-full md:h-[640px]">
        <div className="content_container relative z-20 flex-1 text-[#2C2C2C] max-xl:px-6 md:text-white">
          <h2 className="pt-0 text-center text-lg font-bold md:pt-[4.5rem] md:text-2xl lg:text-3xl xl:text-4xl">
            {props.data?.title}
          </h2>

          <div className="hidden justify-center space-x-20 pb-24 pt-5 md:flex">
            {props.data?.data?.map((item, index) => (
              <div
                key={index}
                onClick={() => run(index)}
                className={cn(
                  "relative flex cursor-pointer items-center pb-1 text-base font-normal opacity-80 transition-all duration-300 after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-0 after:bg-white after:transition-all after:duration-200 lg:text-lg",
                  {
                    "font-bold opacity-100 after:w-full": index === value,
                  }
                )}>
                {item.title}
              </div>
            ))}
          </div>

          <div className="relative hidden md:block">
            {props.data?.data?.map((current, index) => (
              <div
                key={index}
                className={cn(
                  "absolute left-0 flex w-1/2 flex-col space-y-5 opacity-0",
                  {
                    "opacity-100": index === value,
                  }
                )}>
                {current?.icon && (
                  <div className="relative h-9 w-9">
                    <DirectusImage
                      id={current?.icon}
                      alt={current?.title}
                      fill
                    />
                  </div>
                )}

                <div
                  className={cn(
                    "translate-y-20 text-3xl font-bold opacity-0 transition-all duration-500",
                    {
                      "translate-y-0 opacity-100": index === value,
                    }
                  )}>
                  {current?.title}
                </div>

                <div
                  className={cn(
                    "translate-y-20 text-base opacity-0 transition-all duration-700",
                    {
                      "translate-y-0 opacity-100": index === value,
                    }
                  )}>
                  {current?.description}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5 h-[210px] w-full md:hidden">
            <Swiper
              className="h-full w-full"
              slidesPerView={1}
              pagination={{
                clickable: true,
                bulletClass: "swiper-pagination-bullet cases-bullet",
                bulletActiveClass:
                  "swiper-pagination-bullet-active cases-bullet-active",
              }}>
              {props.data?.data?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="relative h-[180px] w-full overflow-hidden rounded-xl">
                    <DirectusImage id={item.image} alt={item.title} fill />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="absolute left-0 top-0 hidden h-full w-full md:block">
          <div className="pointer-events-none absolute inset-0 z-10 h-full w-full bg-[#2C2C2C] opacity-60"></div>
          {props.data?.data?.map((item, index) => (
            <div
              key={index}
              className={cn(
                "absolute left-0 top-0 h-full w-full opacity-0 transition-opacity duration-500",
                {
                  "opacity-100": index === value,
                }
              )}>
              <DirectusImage
                id={item.image}
                alt={item.title}
                fill
                className="object-cover object-center"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
